import { find, first } from 'lodash';
import React from 'react';
import { FilterButton } from 'src/pages/consumer/components/DishFirstHeader';
import {
  useCuisineFilterButtonState,
  useCuisineFiltersReducer,
  useIsContentShowing,
} from 'src/pages/consumer/components/DishFirstHeader/store';
import { useCachedDishFirstFilters } from '../../hooks';
import { useAllCuisinesShowing } from '../../store';
import { formatCuisines, getRootCuisineForCuisine } from '../ExploreFilterModals/CuisineFilterModal/utils';

export const CuisineFilterButton: React.FC = () => {
  const { isShowing, toggle } = useCuisineFiltersReducer();
  const { showAllCuisines } = useAllCuisinesShowing();
  const { filters, availableCuisineCategories, allCuisineCategories } = useCachedDishFirstFilters({
    onChangeFilters: showAllCuisines,
  });

  const { cuisineFilters } = filters;

  const cuisineFilterButtonIsShowing = useCuisineFilterButtonState();
  const isContentShowing = useIsContentShowing();
  const selectedCuisineId = first(cuisineFilters) ?? '';
  const selectedCuisine = find(allCuisineCategories, { id: selectedCuisineId });
  const rootCuisine = getRootCuisineForCuisine(selectedCuisine);
  const formattedCuisines = formatCuisines(selectedCuisine, rootCuisine, availableCuisineCategories);

  const hasCuisineSelection = formattedCuisines.some((x) => x.isSelected);

  return (
    <FilterButton
      isActive={isShowing}
      onClick={toggle}
      order={1}
      show={cuisineFilterButtonIsShowing || isContentShowing}
      hasSelection={hasCuisineSelection}>
      {rootCuisine?.title ?? selectedCuisine?.title ?? 'All cuisines'}
    </FilterButton>
  );
};
